<div class="h-100 overflow-auto">
    <div class="container-sm-fluid pt-3 px-sm-4">
        <dx-tabs
            keyExpr="type"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [showNavButtons]="false"
            stylingMode="primary"
            class="mb-2"
            (onItemClick)="onTabClick($event.itemData.type)"
        ></dx-tabs>
    </div>

    @switch (selectedTab) {
        @case (TabType.OrderPlanningMix) {
            <app-order-planning-mix></app-order-planning-mix>
        }
        @case (TabType.PreProductionOrders) {
            <app-pre-production-orders></app-pre-production-orders>
        }
        @case (TabType.PostProductionMdt) {
            <app-post-production-mdt></app-post-production-mdt>
        }
    }
</div>
